<template>
  <div class="cashflow-app">
    <div class="household-name-container" v-bind:class="{ 'with-notification': showNotification }">
      <div class="title">היי {{ householdName }}</div>
    </div>
    <div v-if="barState" class="cashflow-state-bar-container" v-bind:class="{ 'without-notification': !showNotification }">
      <cashflow-state-bar/>
    </div>
    <div class="cashflow-with-notification" v-bind:class="{ 'shadow-container': showNotification }">
      <notification v-if="showNotification"/>
      <div class="cashflow-container" v-bind:class="{ 'with-notification': showNotification }">
        <cashflow-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Segment from '../../../../../Segment';
import CashflowView from './cashflow-view/CashflowView.vue';
import Notification from './notification/Notification.vue';
import casfhlowHistory from '../../../../../store/utilities/cashflow-history';
import CashflowStateBar from '../../../../../base-components/CashflowStateBar.vue';

export default {
  name: 'CashflowApp',
  components: {
    CashflowView,
    Notification,
    CashflowStateBar,
  },
  async created() {
    Segment.trackUserGot('CashflowViewEntered', { cashflowApp: true });
    this.startLoading(this.$options.name);
    await this.initBudgets({ budgetDate: this.budgetDate, allowViewCurrentMonth: true });
    await this.initApplicationState();
    if (this.notificationState === this.notificationTypes.ACCOUNT_QUESTIONS) {
      await this.fetchQuestions();
    }
    if (this.notificationState === this.notificationTypes.MERGE_QUESTIONS) {
      await this.fetchMergeQuestions();
    }
    this.doneLoading(this.$options.name);
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapGetters('cashflowView', ['budgetUpdatedAt', 'isPresentingLatestMonth']),
    ...mapState('applicationState', ['cashflowState', 'notificationState', 'barState']),
    ...mapGetters('applicationState', ['notificationTypes', 'isActiveNotification']),
    showNotification() {
      return this.isActiveNotification && this.isPresentingLatestMonth;
    },
    budgetDate() {
      const currentBudgetDate = casfhlowHistory.getCurrentBudgetDate();
      return this.$route.query.msg === 'eom' ? casfhlowHistory.getPrevBudgetDate(currentBudgetDate) : currentBudgetDate;
    },
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('applicationState', ['initApplicationState']),
    ...mapActions('cashflowView', ['initBudgets']),
    ...mapActions('accountInvestigationQuestions', ['fetchQuestions']),
    ...mapActions('mergeInvestigationQuestions', ['fetchMergeQuestions']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

.cashflow-app {
  font-family: SimplerPro;

  .household-name-container {
    width: 100%;
    padding-bottom: 20px;

    &.with-notification {
      border-bottom: 1px solid $riseup_gray_0;
    }

    .title {
      width: 100%;
      @include responsive-padding;
      font-family: GretaSans;
      font-size: 24px;
      line-height: 26px;
      padding-top: 16px;
    }
  }
  .cashflow-state-bar-container {
    &.without-notification {
      margin-bottom: 20px;
    }
  }
  .cashflow-with-notification {
    &.shadow-container {
      background-color: $riseup_white_1;
    }

    .cashflow-container {
      &.with-notification {
        background-color: $riseup_white;
        border-radius: 8px 8px 0 0;
        box-shadow: 0 -1px 5px 0 rgba(0, 0, 0, 0.2);
        padding: 16px 0;
        height: 100%
      }
    }
  }
  }
</style>
